import React from 'react';

const GradientOverlay = ({ children, className = '' }) => {
  return (
    <div 
      className={`relative w-full ${className}`}
    >
      {/* Content */}
      {children}
      
      {/* Gradient Overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.64) 100%)',
          zIndex: 1
        }}
      />
    </div>
  );
};

export default GradientOverlay;
